import React from "react";
import { StaticImage } from "gatsby-plugin-image";

const imgDir = "../../components/site/markets/images";

export const gamingList = [
  {
    title: "Block Illegal App Copies",
    text: `<a href="https://approov.io/mobile-app-security/rasp/app-attestation/">Approov app attestation</a> blocks everything except your genuine and untampered mobile app, running in a safe environment from accessing your backend API’s, so you can eliminate the threat of cloned and copied apps once and for all.`,
    icon: (
      <StaticImage
        src={`${imgDir}/ic-gaming-1.png`}
        alt="Mobile Gaming Item"
        className="w-[38px] h-[38px]"
      />
    )
  },
  {
    title: "Detect and Block Cheating Tools and Emulators",
    text: "Approov safeguards against cheat engines, including GameGuardian, and detects emulators like BlueStacks to ensure your mobile game functions as intended, thwarting cheaters.",
    icon: (
      <StaticImage
        src={`${imgDir}/ic-gaming-2.png`}
        alt="Mobile Gaming Item"
        className="w-[38px] h-[38px]"
      />
    )
  },
  {
    title: "Block Rooted, Jailbroken and Modified Devices",
    text: `Approov protects  iOS, WatchOS, Android and HarmonyOS by detecting rooted or jailbroken devices as well as the presence of <a href="https://approov.io/knowledge/what-is-gameguardian">GameGuardian</a>, Cycript, Cydia, Xposed, Frida, Magisk, Zygisk and others.`,
    icon: (
      <StaticImage
        src={`${imgDir}/ic-gaming-3.png`}
        alt="Mobile Gaming Item"
        className="w-[38px] h-[38px]"
      />
    )
  },
  {
    title: "Protect Against Runtime Attacks on the Game",
    text: "Dynamic instrumentation tools can tweak mobile games at runtime. Approov RASP attests the actual executing code, providing robust and continuous protection against any runtime tampering.",
    icon: (
      <StaticImage
        src={`${imgDir}/ic-gaming-4.png`}
        alt="Mobile Gaming Item"
        className="w-[38px] h-[38px]"
      />
    )
  },
  {
    title: "Stop Man-in-the-Middle Attacks",
    text: `By intercepting and modifying SSL certificate checks an attacker can intercept and manipulate encrypted data.  <a href="https://approov.io/mobile-app-security/rasp/dynamic-cert-pinning/">Approov Dynamic Certificate Pinning</a> protects from mobile <a href="https://approov.io/info/how-to-prevent-mitm-attacks-btw-mobile-apps-and-apis">Man-in-the-Middle attacks</a> and makes it easy to manage and rotate certificates over-the-air.`,
    icon: (
      <StaticImage
        src={`${imgDir}/ic-gaming-5.png`}
        alt="Mobile Gaming Item"
        className="w-[38px] h-[38px]"
      />
    )
  },
  {
    title: "Prevent Exploitation of Secrets",
    text: `Approov keeps API keys and certificates securely in the cloud, delivering them “just-in-time” only when app and device integrity checks are passed. You can rotate them easily and immediately via <a href="https://approov.io/product/app-protection">over-the-air updates</a>. It also works for any third party APIs you use.`,
    icon: (
      <StaticImage
        src={`${imgDir}/ic-gaming-6.png`}
        alt="Mobile Gaming Item"
        className="w-[38px] h-[38px]"
      />
    )
  },
  {
    title: "Stop Bypassing Payments",
    text: "You monetize your game with in-app purchases (IAPs), but attackers can use hacking tools to bypass protections and  access these paid features for free. Approov detects and blocks any manipulation and stops any attempts to bypass in-app purchases.",
    icon: (
      <StaticImage
        src={`${imgDir}/ic-gaming-7.png`}
        alt="Mobile Gaming Item"
        className="w-[38px] h-[38px]"
      />
    )
  },
  {
    title: "Prevent Player Account Takeover",
    text: "Only your app has access to your APIs, preventing automated credential stuffing scripts from compromising players' online accounts. Approov ensures that only requests from an authentic, unaltered version of your game are allowed, thwarting hacking attempts arising from data breaches in other gaming services.",
    icon: (
      <StaticImage
        src={`${imgDir}/ic-gaming-8.png`}
        alt="Mobile Gaming Item"
        className="w-[38px] h-[38px]"
      />
    )
  },
]

export const experienceList = [
  {
    title: "Real Time Threat Intelligence",
    text: "Empower your security team with real-time tracking and management of threats. Gain insights into potential risks and take swift, informed actions to protect your mobile applications.",
    icon: (
      <StaticImage
        src={`${imgDir}/gaming-experience-1.png`}
        className="min-w-[54px] h-[51px]"
        alt="Gaming Experience Item"
        objectFit="contain"
      />
    )
  },
  {
    title: "Seamless Customer Experience",
    text: "Over-the-air updates mean secrets and policies can be updated immediately without needing to update code and  deploy a new version of your game.",
    icon: (
      <StaticImage
        src={`${imgDir}/gaming-experience-2.png`}
        className="w-[54px] h-[51px]"
        alt="Gaming Experience Item"
        objectFit="contain"
      />
    )
  },
  {
    title: "Effortless Deployment and Operation",
    text: "Enjoy instant protection without the burden of complex security measures or excessive management overhead. Seamlessly integrate Approov into your DevOps pipeline for a streamlined workflow.",
    icon: (
      <StaticImage
        src={`${imgDir}/gaming-experience-3.png`}
        className="w-[54px] h-[51px]"
        alt="Gaming Experience Item"
        objectFit="contain"
      />
    )
  },
  {
    title: "Scalability Without Compromise",
    text: "As your user base expands, Approov ensures a seamless customer experience. It maintains optimal game performance, never obstructs legitimate users, and effortlessly scales to accommodate millions of users. ",
    icon: (
      <StaticImage
        src={`${imgDir}/gaming-experience-4.png`}
        className="w-[54px] h-[51px]"
        alt="Gaming Experience Item"
        objectFit="contain"
      />
    )
  },
]

export const mobileFinanceGamingList = [
  {
    title: "Block Illegal App Copies",
    text: `<a href="https://approov.io/mobile-app-security/rasp/app-attestation/">Approov app attestation</a> blocks everything except your genuine and untampered mobile app, running in a safe environment from accessing your backend API’s, so you can eliminate the threat of cloned and copied apps once and for all.`,
    icon: (
      <StaticImage
        src={`${imgDir}/ic-gaming-1.png`}
        alt="Mobile Gaming Item"
        className="w-[38px] h-[38px]"
      />
    )
  },
  {
    title: "Detect and Block Runtime Frameworks on the Device",
    text: "Approov safeguards against tools installed on the client device to ensure no-one can interfere with your apps functions at runtime.",
    icon: (
      <StaticImage
        src={`${imgDir}/ic-gaming-2.png`}
        alt="Mobile Gaming Item"
        className="w-[38px] h-[38px]"
      />
    )
  },
  {
    title: "Block Rooted, Jailbroken and Modified Devices",
    text: `Approov protects iOS, WatchOS, Android and HarmonyOS by detecting rooted or jailbroken devices as well as the presence of Cycript, Cydia, Xposed, Frida, Magisk, Zygisk and others.`,
    icon: (
      <StaticImage
        src={`${imgDir}/ic-gaming-3.png`}
        alt="Mobile Gaming Item"
        className="w-[38px] h-[38px]"
      />
    )
  },
  {
    title: "Protect Against Runtime Attacks on your App",
    text: "Dynamic instrumentation tools can tweak aps at runtime. Approov RASP attests the actual executing code, providing robust and continuous protection against any runtime tampering.",
    icon: (
      <StaticImage
        src={`${imgDir}/ic-gaming-4.png`}
        alt="Mobile Gaming Item"
        className="w-[38px] h-[38px]"
      />
    )
  },
  {
    title: "Stop Man-in-the-Middle Attacks",
    text: `By intercepting and modifying SSL certificate checks an attacker can intercept and manipulate encrypted data.  <a href="https://approov.io/mobile-app-security/rasp/dynamic-cert-pinning/">Approov Dynamic Certificate Pinning</a> protects from mobile <a href="https://approov.io/info/how-to-prevent-mitm-attacks-btw-mobile-apps-and-apis">Man-in-the-Middle attacks</a> and makes it easy to manage and rotate certificates over-the-air.`,
    icon: (
      <StaticImage
        src={`${imgDir}/ic-gaming-5.png`}
        alt="Mobile Gaming Item"
        className="w-[38px] h-[38px]"
      />
    )
  },
  {
    title: "Protect App Secrets",
    text: `Approov keeps API keys and certificates securely in the cloud, delivering them “just-in-time” only when app and device integrity checks are passed. You can rotate them easily and immediately via <a href="https://approov.io/product/app-protection">over-the-air updates</a>.`,
    icon: (
      <StaticImage
        src={`${imgDir}/ic-gaming-6.png`}
        alt="Mobile Gaming Item"
        className="w-[38px] h-[38px]"
      />
    )
  },
  {
    title: "Protect Third-Party API Access",
    text: `You need to secure any third-party transfer or payment APIs your app uses, especially if you pay for the service. Approve manages and protects third-party API keys and when they change, you can rotate them easily and immediately via <a href="https://approov.io/product/app-protection">over-the-air updates</a>.`,
    icon: (
      <StaticImage
        src={`${imgDir}/ic-gaming-7.png`}
        alt="Mobile Gaming Item"
        className="w-[38px] h-[38px]"
      />
    )
  },
  {
    title: "Prevent Credential Stuffing and  Account Takeover",
    text: "Only your app has access to your APIs, preventing automated credential stuffing scripts from compromising players' online accounts. Approov ensures that only requests from an authentic, unaltered version of your app are allowed, thwarting hacking attempts arising from data breaches of user credentials.",
    icon: (
      <StaticImage
        src={`${imgDir}/ic-gaming-8.png`}
        alt="Mobile Gaming Item"
        className="w-[38px] h-[38px]"
      />
    )
  },
]

export const mobileFinanceExperienceList = [
  {
    title: "Real Time Threat Intelligence",
    text: "Empower your security team with real-time tracking and management of threats. Gain insights into potential risks and take swift, informed actions to protect your mobile applications.",
    icon: (
      <StaticImage
        src={`${imgDir}/gaming-experience-1.png`}
        className="min-w-[54px] h-[51px]"
        alt="Gaming Experience Item"
        objectFit="contain"
      />
    )
  },
  {
    title: "Seamless Customer Experience",
    text: "Over-the-air updates mean secrets and policies can be updated immediately without needing to update code and deploy a new version of your app. Service continuity is preserved.",
    icon: (
      <StaticImage
        src={`${imgDir}/gaming-experience-2.png`}
        className="w-[54px] h-[51px]"
        alt="Gaming Experience Item"
        objectFit="contain"
      />
    )
  },
  {
    title: "Effortless Deployment and Operation",
    text: "Enjoy instant protection without the burden of complex security measures or excessive management overhead. Seamlessly integrate Approov into your DevOps pipeline for a streamlined workflow.",
    icon: (
      <StaticImage
        src={`${imgDir}/gaming-experience-3.png`}
        className="w-[54px] h-[51px]"
        alt="Gaming Experience Item"
        objectFit="contain"
      />
    )
  },
  {
    title: "Scalability Without Compromise",
    text: "As your user base expands, Approov ensures a seamless customer experience. It maintains app performance, never obstructs legitimate users, and effortlessly scales to accommodate millions of users.",
    icon: (
      <StaticImage
        src={`${imgDir}/gaming-experience-4.png`}
        className="w-[54px] h-[51px]"
        alt="Gaming Experience Item"
        objectFit="contain"
      />
    )
  },
]
